var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"organization-metric"},[_c('div',{staticClass:"metric-count"},[_vm._v(_vm._s(_vm.count))]),_c('div',{staticClass:"metric-value",class:{ 'metric-value-zero': _vm.value === 0 }},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }